import { render, staticRenderFns } from "./AssetFileSelector.vue?vue&type=template&id=51948314&"
import script from "./AssetFileSelector.vue?vue&type=script&lang=ts&"
export * from "./AssetFileSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AssetFileSelector.vue?vue&type=style&index=0&id=51948314&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports